import React, { useState, useEffect } from 'react';
import { Switch, Select, Table, Tag, Modal, Row, Col, Button, Form, Input, DatePicker, Radio, Tooltip } from 'antd';
import { PageHeader } from '../components/page-headers/page-headers';
import axios from '../backendServiceWithoutTimeout';
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import Cookies from 'js-cookie';
import defaultProfilePic from './Default_pfp.svg.png'; // Ensure the path is correct

function UserInfo() {
  const [userInfo, setUserInfo] = useState();

  const data = {
    userId: Cookies.get('userId'),
  };

  const fetchData = async () => {
    const response = await axios.post(`/users/formwise-userData`, data);
    console.log(response.data, '---------------------------------response');
    setUserInfo(response.data.user_info);
  };

  useEffect(() => {
    fetchData();
  }, []);
  const columns = [
    {
      title: 'Image',
      key: 'image',
      render: (text, record) => {
        const imageUrl = record.image && record.image.startsWith('data:image') ? record.image : defaultProfilePic;
        return (
          <img
            src={imageUrl}
            alt={record.userName}
            style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
          />
        );
      },
    },
    { title: 'Name', dataIndex: 'userName', key: 'userName' },
    { title: 'Number', dataIndex: 'phoneNumber', key: 'phoneNumber' },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '100px',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Date of Birth',
      dataIndex: 'dob',
      key: 'dob',
      render: (dob) => {
        const formattedDob = new Date(dob).toLocaleDateString('en-GB');
        return formattedDob;
      },
    },
    { title: 'City', dataIndex: 'city', key: 'city' },
    { title: 'State', dataIndex: 'state', key: 'state' },
    { title: 'Gender', dataIndex: 'gender', key: 'gender' },
    { title: 'RefCode', dataIndex: 'refCode', key: 'refCode' },
    { title: 'Wallet Points', dataIndex: 'walletPoint', key: 'walletPoint', align: 'center' },
    {
      title: 'Courses',
      dataIndex: 'courses',
      key: 'courses',
      align: 'center',
      render: (courses) => (
        <span className="grid grid-cols-2 items-center justify-center gap-2">
          {courses.map((course) => (
            <Tag key={course._id} color="blue">
              {course.courseName}
            </Tag>
          ))}
        </span>
      ),
    },
    {
      title: 'Batches',
      dataIndex: 'batches',
      key: 'batches',
      align: 'center',
      render: (batches) => (
        <span className="grid grid-cols-2 items-center justify-center gap-2">
          {batches.map((batch) => (
            <Tag key={batch._id} color="blue">
              {batch.name}
            </Tag>
          ))}
        </span>
      ),
    },
    {
      title: 'Subjects',
      dataIndex: 'subjects',
      key: 'subjects',
      align: 'center',
      render: (subjects) => (
        <span className="grid grid-cols-2 items-center justify-center gap-2">
          {subjects.map((subject) => (
            <Tag key={subject._id} color="blue">
              {subject.subjectName}
            </Tag>
          ))}
        </span>
      ),
    },
  ];

  return (
    <>
      <PageHeader className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col" />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
              <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                <div className="flex items-center gap-[15px]">
                  <h1 className="mb-0 mr-12 text-ellipsis text-[18px] font-semibold sm:text-center">Teacher Info</h1>
                </div>
              </div>

              <div className="mt-0.5">
                <GlobalUtilityStyle>
                  <PaginationStyle>
                    <div className="ant-pagination-custom-style table-responsive hover-tr-none table-th-shape-none table-last-th-text-right table-th-border-none table-head-rounded table-selection-col-pl-25 table-tr-selected-background-transparent table-td-border-none bg-white dark:bg-transparent rounded-[10px] ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-none ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-none">
                      <Table dataSource={userInfo ? [userInfo] : []} columns={columns} />
                    </div>
                  </PaginationStyle>
                </GlobalUtilityStyle>
              </div>
            </div>
          </Col>
        </Row>
      </main>
    </>
  );
}

export default UserInfo;
